import { MedicationItemContent } from "../molecules/MedicationItemContent";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { Link } from "ui/gluestack/link";
import { usePathname } from "expo-router";
import { View } from "ui/atoms/view";
import { MedicationAdministrationStatusEnum } from "../../../services/api/types/medications/enums/MedicationAdministrationStatusEnum";

interface MedicationItemProps {
  medication: MedicationModel;
  isViewing?: boolean;
  startEditMedication?: (medication: MedicationModel) => void;
  startDiscontinueMedication?: (medication: MedicationModel) => void;
  isDiscontinued?: boolean;
  startAddNoteOrVoid?: (medication: MedicationModel) => void;
  medicationLogStatus?: MedicationAdministrationStatusEnum;
}

export function MedicationItem({
  medication,
  isViewing = false,
  startEditMedication,
  startDiscontinueMedication,
  isDiscontinued,
  startAddNoteOrVoid,
  medicationLogStatus,
}: MedicationItemProps) {
  const path = usePathname();
  const medicationLink = `${path}/${medication.id}`;

  if (isViewing) {
    return (
      <View
        className={`rounded-xl border border-border-200 w-full ${isDiscontinued ? `bg-gray-100 ` : null}`}
      >
        <MedicationItemContent
          medication={medication}
          isViewing
          startEditMedication={startEditMedication}
          startDiscontinueMedication={startDiscontinueMedication}
          isDiscontinued={isDiscontinued}
          startAddNoteOrVoid={startAddNoteOrVoid}
          medicationLogStatus={medicationLogStatus}
        />
      </View>
    );
  }

  return (
    <Link
      href={medicationLink}
      className={`rounded-xl border border-border-200 w-full ${isDiscontinued ? `bg-gray-100 ` : null}`}
    >
      <MedicationItemContent
        medication={medication}
        viewMoreLink={medicationLink}
      />
    </Link>
  );
}
